import React from 'react';
import { useUserStore } from '../store/userStore';

const DebugUserData: React.FC = () => {
  const { currentUser } = useUserStore();

  if (process.env.NODE_ENV !== 'development') {
    return null; // Only show in development mode
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-80 text-white p-4 rounded-lg max-w-md z-50">
      <h3 className="font-bold text-yellow-400 mb-2">🔍 Debug: User Data</h3>
      {currentUser ? (
        <pre className="text-xs overflow-auto max-h-60">
          {JSON.stringify(
            {
              id: currentUser.id,
              name: currentUser.name,
              user_number: currentUser.user_number,
              member_number: currentUser.member_number,
              phone: currentUser.phone,
              email: currentUser.email,
              role: currentUser.role,
            },
            null,
            2
          )}
        </pre>
      ) : (
        <p className="text-yellow-400">No user logged in</p>
      )}
    </div>
  );
};

export default DebugUserData;